import {useMutation, useQuery} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {components} from '@/lib/api-schema'

export type RegistroLink = components['schemas']['RegistroLinkRead']
export type RegistroPage1Payload = components['schemas']['RegistroPage1Create']
export type RegistroPage1Result = components['schemas']['RegistroPage1Read']

/** No auth; a dead, revoked or deleted-business token all 404 alike. */
export function useRegistroLink(token: string) {
  return useQuery({
    queryKey: ['registro-link', token],
    queryFn: async () => (await api.get<RegistroLink>(`/registro/${token}`)).data,
  })
}

/** Same endpoint for a cédula-only probe or the full identity payload; `registro.tsx` picks the shape. */
export function useSubmitRegistro(token: string) {
  return useMutation({
    mutationFn: async (payload: RegistroPage1Payload) =>
      (await api.post<RegistroPage1Result>(`/registro/${token}`, payload)).data,
  })
}

export type RegistroEmpresaPayload = components['schemas']['RegistroEmpresaCreate']
export type RegistroEmpresaResult = components['schemas']['RegistroEmpresaRead']
export type CedulaProbeResult = components['schemas']['CedulaProbeRead']

/** Auth optional: a logged-in owner creates it without a password; a cédula with an account gets 409. */
export function useRegistroEmpresa() {
  return useMutation({
    mutationFn: async (payload: RegistroEmpresaPayload) =>
      (await api.post<RegistroEmpresaResult>('/registro/empresa', payload)).data,
  })
}

/** Neutral probe shared by business and employee-by-link registration. */
export function useProbeCedula() {
  return useMutation({
    mutationFn: async (cedula: string) =>
      (await api.post<CedulaProbeResult>('/registro/empresa/probe-cedula', {cedula})).data,
  })
}
